import * as React from 'react'

import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'

import Content from './Content'
import Layout from './Layout'
import FaceRecognitionLogsForm from './Layout/form'

interface Props {
  employeeId: number
  employeeFullName: string
  contractStartsOn: Date | null
}

const Logs = ({ employeeId, employeeFullName, contractStartsOn }: Props) => {
  const logsForm = React.useRef(
    new FaceRecognitionLogsForm({
      date: dateToString(moment(), 'backend'),
    })
  ).current

  return (
    <Layout
      employeeId={employeeId}
      employeeFullName={employeeFullName}
      logsForm={logsForm}
      contractStartsOn={contractStartsOn}
    >
      <Content employeeId={employeeId} employeeFullName={employeeFullName} logsForm={logsForm} />
    </Layout>
  )
}

export default Logs
